"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOfferTypeConditions = exports.getFilteredConditions = exports["default"] = void 0;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var EXCLUDED_CONDITIONS = ['on-hospital-and-extras', 'on-eligible-hospital-and-extras'];
var getOfferTypeConditions = exports.getOfferTypeConditions = function getOfferTypeConditions(_ref) {
  var hasConditionsGroup = _ref.hasConditionsGroup,
    hasSpecificConditions = _ref.hasSpecificConditions;
  var conditions = (0, _fp.flatMap)(function (_ref2) {
    var containsConditions = _ref2.containsConditions;
    return containsConditions;
  }, hasConditionsGroup);
  return (0, _fp.concat)(conditions, hasSpecificConditions || []);
};

// eslint-disable-next-line @typescript-eslint/ban-types
var getFilteredConditions = exports.getFilteredConditions = function getFilteredConditions(offer) {
  return (0, _lodash["default"])(offer).chain().get('offerTypes')
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  .flatMap(getOfferTypeConditions).filter({
    importance: 'high'
  }).reject(function (_ref3) {
    var current = _ref3.identifier.current;
    return (0, _fp.includes)(current, EXCLUDED_CONDITIONS);
  }).value();
};
var appliesToNewJoinsOnly = function appliesToNewJoinsOnly(offer) {
  return !(0, _fp.isEmpty)(getFilteredConditions(offer));
};
var _default = exports["default"] = appliesToNewJoinsOnly;